import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

class StatGraphForm extends Component {
    @autobind
    handleChange(value, property) {
        const { onChange } = this.props
        let newObject = {};
        newObject[property] = value;
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props;
        return (

            <div className="desc_plugin26">
                <p className="txt_plugin">
                    설정 후 스킨 치환자를 스킨에 삽입하면 방문자 통계 그래프를 사이드바 또는 스킨의 원하는 위치에 추가할 수 있습니다.
                </p>
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        스킨 치환자는 <span className="txt_em">[##_StatisticsGraph_##]</span> 입니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

StatGraphForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default StatGraphForm
